import {
  AuthAction,
  AuthState,
  LOGOUT,
  SET_ERROR_LOGIN,
  SET_LOGINING,
  SET_PROFILE,
  SET_PROFILE_LOADED,
} from '../types'

const initialState: AuthState = {
  profile: null,
  logining: false,
  error: '',
  isProfileLoaded: false,
}

export const authReducer = (
  state = initialState,
  action: AuthAction
): AuthState => {
  switch (action.type) {
    case SET_PROFILE:
      return {
        ...state,
        profile: action.payload,
      }
    case SET_PROFILE_LOADED:
      return {
        ...state,
        isProfileLoaded: action.payload,
      }
    case SET_ERROR_LOGIN:
      return {
        ...state,
        error: action.payload,
      }
    case LOGOUT:
      return {
        ...state,
        profile: null,
        isProfileLoaded: true,
      }
    case SET_LOGINING:
      return {
        ...state,
        logining: action.payload,
      }
    default:
      return state
  }
}
